import React from 'react'
import ContactHero from '../components/ContactHero'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ContactForm from '../components/ContactForm'
import OfficeMap from '../components/OfficeMap'
import FAQSection from '../components/FAQSection'

const Contact = () => {
  return (
    <div>
        <Navbar/>
      <ContactHero/>
      <ContactForm/>
      <OfficeMap/>
      <FAQSection/>
      <Footer/>
    </div>
  )
}

export default Contact
